module.exports = __webpack_public_path__ + "img/6-low.90e5aa10.jpg";